/* eslint-disable no-bitwise */
const { lighten } = require('@virtual-peaker/vp-common').vpFilters.arithmetic;

export default {
  lighten,
};
